import Vue from 'vue';
import querystring from 'querystring';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre, Cuenta } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
import * as Pedidos from '@lib/Ventas/Pedidos';
import { Categoria } from '@/__env/lib/Web/Categorias';

export class ControladorSeccion
{

    constructor()
    {
    }

    public readonly Buscador: Buscador = new Buscador();
    public Seleccionados: Categoria[] = [];
    public Filtrados: Categoria[] = [];
    public Seleccionado: Categoria = null;
    public Historial: Categoria[] = [];

    Iniciar()
    {
        this.Buscador.Iniciar();
    }




    public Vista: Vista = new Vista();
    private _onSeleccionados = new SignalDispatcher();
    public get onSeleccionados() { return this._onSeleccionados.asEvent(); }

    public RecargarEstadistica()
    {
        this._onRecargarEstadistica.dispatch();
    }
    private _onRecargarEstadistica = new SignalDispatcher();
    public get onRecargarEstadistica() { return this._onRecargarEstadistica.asEvent(); }
}

export class Vista extends VistaBase
{
    public Filtros: FiltrosBase = new FiltrosBase();
}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador
{

    public Items: Categoria[] = [];

    public Filtros: Filtros = new Filtros( this );
    Iniciar()
    {
        this.Filtros = new Filtros( this );
    }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null, agregar: boolean = false )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        if ( !agregar )
        {
            this.Items.clear();
            this.Estado = 'cargando';
        }

        Utiles.setQuery( this.Filtros.get() );
        this._onActualizar.dispatch();


        await Wait( 100 );
        let ff = this.Filtros.Obtener();
        ff.no_limit = 'S';
        let e = await Categoria.find( ff );
        if ( e.Error )
        {
            this.Estado = 'error';
        }
        else
        {
            if ( !agregar )
            {
                this.Items = e.Items;
            } else
            {
                this.Items.push( ...e.Items );
            }

            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';
    public Padre: number = null;

    public Valores: Record<string, any> = {
        Estado: 1,
        Tipo: 0,
        TiposArticulo: 0,
        Limite: 1,
        Orden: 0,
        Indice: 0,
        Cuenta: 0,
        Pagina: 1,
        Tag: 0,
        EnvioGratis: 0,
    };


    public get Cuentas() { return CuentasMercadoLibre; }
    public get Limites() { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }

    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {
        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {
            if ( this.Valores.Cuenta > 0 )
            {
                a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
            }
        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};
        filtro.busqueda = 'S';

        if ( this.Valores.Cuenta > 0 )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }

        if ( this.Padre > 0 )
        {
            filtro.padre = this.Padre;
        }


        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }



        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }


        if ( filtro.cuenta )
        {
            this.Valores.Cuenta = 0;
            let idx = this.Cuentas.findIndex( x => x.Nombre.toLowerCase().eliminar( ' ' ) == filtro.cuenta );
            if ( idx > 0 ) this.Valores.Cuenta = idx;
        }



        if ( filtro.limit )
        {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }



        if ( this.Valores.Cuenta > 0 )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Nombre.eliminar( ' ' );


        }



        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }



        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}

const Controlador = new ControladorSeccion();
export { Controlador };

